export default class GameObject {

	dispose() { }
}